export default __webpack_public_path__ + "static/media/nba-player-mobile.2ee89738.png";